import { css } from 'lit-element'

export const JWPlayerStyle = css`
	atype-video-jwplayer {
		display: block;
		max-width: 100%;
		position: relative;
		aspect-ratio: var(--aspect-ratio, 16 / 9);
	}
	atype-video-jwplayer[with-title] {
    	--titleHeight: var(--title-height, 3.5em);
    	--primaryTextColor: var(--primary-text-color, #8a8a8a);
    	--secondaryTextColor: var(--secondary-text-color, #141414);
    	--backgroundColor: var(--title-background-color, #fefefe);
    	--borderColor: var(--border-color, #cacaca);
    	--titleFontSize: var(--video-title-font-size, 1.0em);

    	--primaryTitleFontSize: 1.0em;
    	--titlePaddingBottom: 0.5em;
    	--titleWrap: normal;
    }

	@media(min-width: 426px){
    	atype-video-jwplayer[with-title] {
    		--titleHeight: var(--title-height, 4em);
    		--primaryTitleFontSize: 1.25em;
        	--titlePaddingBottom: 0.25em;
        	--titleWrap: nowrap;
    	}
	}
    atype-video-jwplayer[with-title] .jwplayer {
        overflow: visible;
        margin-bottom: calc(var(--titleHeight) + 8px);
        font-size: var(--titleFontSize);
    }

    atype-video-jwplayer[with-title] .jw-title {
		font-size: var(--titleFontSize);
        display: block;
        top: unset;
        bottom: 0;
        padding: 0;
        transform: translate(0, var(--titleHeight));
        padding: .5em;
        height: var(--titleHeight);
        overflow: hidden;
        white-space: normal;
        background-color: var(--backgroundColor);
        border: 1px solid var(--borderColor);
    }

    atype-video-jwplayer[with-title] .jw-title-primary  {
		color: var(--primaryTextColor);
        font-size: var(--primaryTitleFontSize);
        line-height: 1.25em;
        padding: 0;
        padding-bottom: var(--titlePaddingBottom);
        white-space: var(--titleWrap);
        font-family: "Montserrat" !important;
        font-weight: 200;
    }
    atype-video-jwplayer[with-title] .jw-title-secondary {
        display: block;
        padding: 0;
        white-space: nowrap;
        font-family: "Montserrat" !important;
        color: var(--secondaryTextColor);
    }

    .jw-flag-floating .jw-wrapper {
        background: transparent;
    }
    .jw-float-icon {
        display: none;
        position: absolute;
        left: 0rem;
        align-items: center;
        justify-content: center;
        width: auto;
        right: auto;
        top: 0;
        background-color: #0009;
        padding: 0.25rem;
    }
    .jw-float-icon:after {
        content: "Close";
        color: #fff;
    }

    .jw-ad-instream {
        z-index: 0;
    }

    span.jw-text.jw-reset.jw-text-alt {
    position: absolute;
    bottom: 4px;
}

    .jw-flag-floating .jw-wrapper {
        left: 1rem;
        right: auto;
    }
    @media(min-width: 481px) {
        .jw-flag-floating .jw-wrapper.jw-reset {
			bottom: initial !important;
			top: calc(var(--nav-height, 48px) + 12px) !important;
			animation-name: jw-float-to-top;
        }
    }
    @media(max-width: 480px){
        .jw-flag-floating .jw-wrapper.jw-reset {
          max-width: 150px !important;
          right: 1rem !important;
          bottom: initial !important;
          margin: 0px !important;
          position: fixed;
          top: 48px !important;
          left: unset !important;
        }

        .jw-flag-floating.jw-flag-touch .jw-slider-time::before {
            content: unset;
        }
        .jw-float-icon {
            display: none;
            position: absolute;
            left: 0rem;
            align-items: center;
            justify-content: center;
            width: auto;
            right: auto;
            top: 0;
            padding: 0.25rem;
        }

        .jw-float-icon:after {
            font-size: 9px;
        }
        .jw-svg-icon {
            height: 14px;
            width: 14px;
        }
        .jw-icon {
            height: 24px;
        }
        span.jw-text.jw-reset.jw-text-alt {
            font-size: 8px;
        }
    }



`